import React from 'react'
import { useEffect, useState } from 'react';
import { getInformationSection } from '../../services/exams/exams';
import { saveConfigurationSurvey, getAllTemplateConfiguration, updateConfigurationSurvey, deleteTemplateConfiguration, enableTemplateConfiguration, updateClausesSurvey } from '../../services/templateSurvey/templateConfiguration';
import { useHistory, useParams, useLocation } from 'react-router-dom';


export const useTemplateSurvey = () => {

    const history = useHistory();

    const { idTemplate } = useParams();

    const location = useLocation();

    const surveyToEdit = location?.state?.survey;


    // * CONFIGURATION STATES
    const [formSurvey, setFormSurvey] = useState({
        title: "",
        department: [],
        version: "1.0.0",
        id_template: null,
        id_user_who_deleted: null,
        patient_signature: false,
        phlebotomist_signature: false

    });

    const [departments, setDepartments] = useState([])
    const [questions, setQuestions] = useState([]);
    const [timeValue, setTimeValue] = useState("");

    // *  TYPE QUESTION 3
    const [selectedClosedOptions, setSelectedClosedOptions] = useState({});
    const [openSubQuestionAnswers, setOpenSubQuestionAnswers] = useState({});
    const [timeSubQuestionAnswers, setTimeSubQuestionAnswers] = useState({});


    // * TYPE MULTIPLE
    const [singleMultipleSubAnswers, setSingleMultipleSubAnswers] = useState({});
    const [multipleSubAnswers, setMultipleSubAnswers] = useState({});
    const [timeNotApplicable, setTimeNotApplicable] = useState(false);


    // * TOAST ALERT
    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState("info");
    const [toastTitle, setToastTitle] = useState("");
    const [toastMessage, setToastMessage] = useState("");


    // * TYPE MULTIPLE
    const [multipleAnswers, setMultipleAnswers] = useState({});
    const [singleAnswers, setSingleAnswers] = useState({});


    // * UPDATE METHOD
    const [listSurveys, setListSurveys] = useState([])


    // * ENABLED TEMPLATE SURVEY
    const [showEnableDialog, setShowEnableDialog] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [loadingStatus, setLoadingStatus] = useState(false);


    // * DELETE TEMPLATE SURVEY
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [templateToDelete, setTemplateToDelete] = useState(null);
    const [loadingDelete, setLoadingDelete] = useState(false);


    // * CLAUSES
    const [showClauses, setShowClauses] = useState(false);
    const [templateToClauses, setTemplateToClauses] = useState(null);
    const [loadingClauses, setLoadingClauses] = useState(false);


    // * ORDER QUESTIONS
    const [showOrderDialog, setShowOrderDialog] = useState(false);
    const [orderQuestions, setOrderQuestions] = useState([]);
    const [draggedQuestionIndex, setDraggedQuestionIndex] = useState(null);
    const [dragOverQuestionIndex, setDragOverQuestionIndex] = useState(null);


    // * CLAUSES
    const [clausesForm, setClausesForm] = useState({
        clauses_1: "",
        clauses_2: "",
        id_template: null,
    });




    // * ALERT
    const [showAlert, setShowAlert] = useState(false);
    const [customAlert, setCustomAlert] = useState({
        visible: false,
        mode: "alert",
        type: "info",
        title: "",
        message: "",
        onAccept: null,
        onCancel: null
    });


    // * FUNCTION EDIT

    const formatQuestion = (question) => {

        const questionType = question?.type ?? "open";

        return {
            ...question,

            id: String(question?.id ?? ""),
            type: questionType,
            question: question?.question ?? "",
            placeholder: question?.placeholder ?? "",
            required: Boolean(question?.required),
            gender: question?.gender ?? "both",
            allowMultiple:
                questionType === "multiple"
                    ? Boolean(question?.allowMultiple)
                    : question?.allowMultiple,
            displayType:
                questionType === "multiple"
                    ? question?.displayType ?? "button"
                    : question?.displayType,

            options: Array.isArray(question?.options)
                ? question.options.map(option => {

                    const subQuestion = option?.subQuestion;

                    return {
                        ...option,
                        id: String(option?.id ?? ""),
                        label:
                            option?.label ??
                            option?.text ??
                            "",
                        value: option?.value ?? "",
                        hasSubQuestion: Boolean(option?.hasSubQuestion),
                        subQuestion: subQuestion
                            ? {
                                ...subQuestion,
                                id: String(subQuestion?.id ?? ""),
                                type: subQuestion?.type ?? "open",
                                question: subQuestion?.question ?? "",
                                placeholder: subQuestion?.placeholder ?? "",
                                required: Boolean(subQuestion?.required),
                                gender: subQuestion?.gender ?? "both",
                                selectionMode:
                                    subQuestion?.allowMultiple
                                        ? "multiple"
                                        : "single",
                                options: Array.isArray(subQuestion?.options)
                                    ? subQuestion.options.map(subOption => ({
                                        ...subOption,
                                        id: String(subOption?.id ?? ""),
                                        label:
                                            subOption?.label ||
                                            subOption?.text ||
                                            "",

                                        value: subOption?.value ?? ""
                                    }))
                                    : []
                            }
                            : null
                    };
                })
                : []
        };
    };


    // * USE EFFECT EDIT

    useEffect(() => {

        if (!surveyToEdit) {
            return;
        }

        setFormSurvey({
            id_template: surveyToEdit?.id_template ?? null,
            title: surveyToEdit?.title ?? "",
            version: surveyToEdit?.version ?? "1.0.0",

            department: Array.isArray(surveyToEdit?.associated_sections)
                ? surveyToEdit.associated_sections.map(Number)
                : [],
            id_user_who_deleted: surveyToEdit?.id_user_who_deleted === 0 ? null : surveyToEdit?.id_user_who_deleted ?? null,
            patient_signature: surveyToEdit?.patient_signature ?? false,
            phlebotomist_signature: surveyToEdit?.phlebotomist_signature ?? false

        });

        const formattedQuestions = Array.isArray(surveyToEdit?.questions)
            ? surveyToEdit.questions.map(formatQuestion)
            : [];

        setQuestions(formattedQuestions);

    }, [surveyToEdit]);


    // * USE EFFECTS

    useEffect(() => {
        getSections()
        getListTemplateSurvey()
    }, [])


    // * CONFIGURATION TIME

    useEffect(() => {

        const interval = setInterval(() => {
            setCurrentTime(getCurrentTime());
        }, 60000);

        return () => clearInterval(interval);

    }, []);


    // * CONFIGURATION ALERTS
    const showCustomAlert = (
        type,
        title,
        message
    ) => {

        setCustomAlert({
            visible: true,
            mode: "alert",
            type,
            title,
            message,
            onAccept: () => {
                setCustomAlert(prev => ({
                    ...prev,
                    visible: false
                }));
            },
            onCancel: null
        });

    };


    // * CONFIGURATION LIST SURVEY
    const createSurvey = () => {
        history.push(`../../plantillas`);
    }

    const LisSurvey = () => {
        history.push(`../listado/de/Consentimientos`);
    }

    const LisSurvey2 = () => {
        history.push(`../../listado/de/Consentimientos`);
    }

    // * CALCULATE TIME
    const getCurrentTime = () => {
        const now = new Date();

        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");

        return `${hours}:${minutes}`;
    };

    const [currentTime, setCurrentTime] = useState(getCurrentTime());


    // * CONFIGURATION HANDLES
    const handleChangeSurvey = (
        field,
        value
    ) => {

        setFormSurvey((previous) => ({
            ...previous,
            [field]: value
        }));
    };


    // * CONFIGURATION SIGNATURE
    const handleToggleSignature = (field) => {
        setFormSurvey((prev) => ({
            ...prev,
            [field]: !prev[field]
        }));
    };



    // * CONFIGURATION ADD QUESTION
    const handleAddQuestion = (
        type
    ) => {

        const questionId = `${Date.now()}-${Math.random()}`;

        let newQuestion;

        switch (type) {

            case "open":
                newQuestion = {
                    id: questionId,
                    type: "open",
                    question: "",
                    placeholder: "",
                    required: false,
                    gender: "both"

                };
                break;

            case "time":
                newQuestion = {
                    id: questionId,
                    type: "time",
                    question: "",
                    required: false,
                    gender: "both"

                };
                break;

            case "complex":
                newQuestion = {
                    id: questionId,
                    type: "complex",
                    question: "",
                    required: false,
                    options: [],
                    gender: "both"

                };
                break;

            case "multiple":
                newQuestion = {
                    id: questionId,
                    type: "multiple",
                    question: "",
                    required: false,
                    allowMultiple: false,
                    displayType: "button",
                    options: [],
                    gender: "both"

                };
                break;

            default:
                return;
        }

        setQuestions((previousQuestions) => [
            ...previousQuestions,
            newQuestion
        ]);
    };


    // * DELETE QUESTION 
    const handleUpdateQuestion = (
        questionId,
        field,
        value
    ) => {

        setQuestions((previousQuestions) =>
            previousQuestions.map((item) =>
                item?.id === questionId
                    ? {
                        ...item,
                        [field]: value
                    }
                    : item
            )
        );
    };


    // * CONFIGURATION DELETE PREVIOS QUESTION
    const handleDeleteQuestion = (
        questionId
    ) => {

        setQuestions((previousQuestions) =>
            previousQuestions.filter(
                (item) => item?.id !== questionId
            )
        );
    };



    // * CONFIGURATION PREVIEW TEMPLATE
    const handleSelectClosedOption = (
        questionId,
        optionValue
    ) => {
        setSelectedClosedOptions((previous) => ({
            ...previous,
            [questionId]: optionValue
        }));
    };


    // * CONFIGURTION SUBMULTIPLE
    const handleMultipleSubAnswer = (
        optionId,
        subOptionValue
    ) => {
        setMultipleSubAnswers((previous) => {
            const currentValues = previous[optionId] || [];

            const alreadySelected =
                currentValues.includes(subOptionValue);

            return {
                ...previous,

                [optionId]: alreadySelected
                    ? currentValues.filter(
                        (value) => value !== subOptionValue
                    )
                    : [
                        ...currentValues,
                        subOptionValue
                    ]
            };
        });
    };



    // * CONFIGURATION TIME
    const calculateFastingTime = (
        selectedTime
    ) => {
        if (!selectedTime) {
            return "";
        }

        const [selectedHours, selectedMinutes] = selectedTime
            .split(":")
            .map(Number);

        const now = new Date();

        const selectedDate = new Date();
        selectedDate.setHours(
            selectedHours,
            selectedMinutes,
            0,
            0
        );


        if (selectedDate > now) {
            selectedDate.setDate(
                selectedDate.getDate() - 1
            );
        }

        const differenceMilliseconds =
            now.getTime() - selectedDate.getTime();

        const totalMinutes = Math.floor(
            differenceMilliseconds / 60000
        );

        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        return `${String(hours).padStart(2, "0")}:${String(
            minutes
        ).padStart(2, "0")}`;
    };



    //? TOAST ALERT 
    const showToastAlert = (
        type = "info",
        title = "",
        message = ""
    ) => {

        setToastType(type);
        setToastTitle(title);
        setToastMessage(message);
        setShowToast(true);
    };


    const closeToastAlert = () => {
        setShowToast(false);
        setToastTitle("");
        setToastMessage("");

    };


    // ? CONFIGURATION TIME
    const fastingTime = calculateFastingTime(timeValue);

    const handleTimeChange = (
        event
    ) => {

        const value = event?.target?.value;

        if (value > currentTime) {
            showToastAlert("warning", "Pregunta de tiempo", "Debe de seleccionar una hora diferente a la actual.");
            return;
        }

        setTimeValue(value);
        setTimeNotApplicable(false);
    };


    // ? TYPE 4
    const handleMultipleAnswerChange = (
        questionId,
        optionIndex
    ) => {

        setMultipleAnswers((previous) => {

            const currentAnswers = Array.isArray(previous[questionId])
                ? previous[questionId]
                : [];

            const alreadySelected = currentAnswers.includes(optionIndex);

            return {
                ...previous,
                [questionId]: alreadySelected
                    ? currentAnswers.filter((index) => index !== optionIndex)
                    : [...currentAnswers, optionIndex]
            };

        });

    };

    const handleSingleAnswerChange = (
        questionId,
        optionIndex
    ) => {

        setSingleAnswers((previous) => ({
            ...previous,
            [questionId]: optionIndex
        }))
    };



    // * CONFIGURATION METHODS
    const getSections = async () => {

        const dataSection = await getInformationSection();

        if (dataSection?.code === 200) {

            const options = dataSection?.data.map((section) => ({
                value: section?.id_section,
                label: section?.name,
                icon: "fa fa-folder-open-o"
            }));
            setDepartments(options);
        }
    };



    // * SAVE TEMPLATES ------
    const buildQuestionPayload = (question) => {
        console.log("🚀 ~ buildQuestionPayload ~ question:", question)

        if (!question) {
            return null;
        }

        const isMultipleQuestion =
            question.type === "multiple";

        return {
            id: question.id || null,

            type: question.type,

            question:
                question.question?.trim() || "",

            placeholder:
                question.placeholder?.trim() || "",

            required:
                Boolean(question.required),

            gender:
                question.gender || "both",

            allowMultiple:
                isMultipleQuestion
                    ? Boolean(question.allowMultiple)
                    : null,

            displayType:
                isMultipleQuestion
                    ? question.displayType || "button"
                    : null,

            options:
                Array.isArray(question.options)
                    ? question.options.map(option => ({
                        id:
                            option.id || null,

                        label:
                            isMultipleQuestion
                                ? null
                                : option.label?.trim() || null,

                        text:
                            isMultipleQuestion
                                ? (
                                    option.text?.trim() ||
                                    option.label?.trim() ||
                                    ""
                                )
                                : null,

                        value:
                            option.value || null,

                        hasSubQuestion:
                            Boolean(option.hasSubQuestion),

                        subQuestion:
                            option.hasSubQuestion &&
                                option.subQuestion
                                ? buildQuestionPayload(
                                    option.subQuestion
                                )
                                : null
                    }))
                    : []
        };
    };

    const getQuestionTypeLabel = (type) => {

        switch (type) {

            case "open":
                return "PREGUNTA ABIERTA";

            case "time":
                return "PREGUNTA DE TIEMPO";

            case "complex":
                return "PREGUNTA CERRADA";

            case "multiple":
                return "OPCIÓN MÚLTIPLE";

            default:
                return "PREGUNTA";
        }
    };


    const findInvalidQuestion = (
        question,
        questionNumber,
        parentPath = ""
    ) => {

        if (!question) {
            return null;
        }

        const questionType =
            String(question?.type || "").toLowerCase();

        const currentPath =
            parentPath
                ? `${parentPath}.${questionNumber}`
                : `${questionNumber}`;

        const questionText =
            String(question?.question || "").trim();


        // 1. VALIDAR QUE TENGA TEXTO
        if (questionText === "") {

            return {
                type: questionType,
                typeLabel:
                    getQuestionTypeLabel(questionType),
                number: currentPath,
                errorType: "question"
            };
        }


        // 2. VALIDAR OPCIONES
        const requiresOptions =
            questionType === "multiple" ||
            questionType === "closed" ||
            questionType === "complex";


        if (requiresOptions) {

            const validOptions =
                Array.isArray(question?.options)
                    ? question.options.filter(option =>
                        String(
                            option?.text ??
                            option?.label ??
                            ""
                        ).trim() !== ""
                    )
                    : [];

            if (validOptions.length === 0) {

                return {
                    type: questionType,
                    typeLabel:
                        getQuestionTypeLabel(questionType),
                    number: currentPath,
                    errorType: "options"
                };
            }
        }


        // 3. VALIDAR SUBPREGUNTAS
        if (Array.isArray(question?.options)) {

            for (
                let optionIndex = 0;
                optionIndex < question.options.length;
                optionIndex++
            ) {

                const option =
                    question.options[optionIndex];

                if (
                    option?.hasSubQuestion &&
                    option?.subQuestion
                ) {

                    const error =
                        findInvalidQuestion(
                            option.subQuestion,
                            optionIndex + 1,
                            currentPath
                        );

                    if (error) {
                        return error;
                    }
                }
            }
        }


        return null;
    };


    const getQuestionTypeStyle = (type) => {

        switch (type) {

            case "open":
                return {
                    color: "#4F46E5",
                    background: "#EEF2FF",
                    border: "#C7D2FE"
                };

            case "time":
                return {
                    color: "#9333EA",
                    background: "#FAF5FF",
                    border: "#E9D5FF"
                };

            case "complex":
                return {
                    color: "#D97706",
                    background: "#FFFBEB",
                    border: "#FDE68A"
                };

            case "multiple":
                return {
                    color: "#059669",
                    background: "#ECFDF5",
                    border: "#A7F3D0"
                };

            default:
                return {
                    color: "#475569",
                    background: "#F8FAFC",
                    border: "#E2E8F0"
                };
        }
    };

    const handleSave = async () => {

        if (formSurvey.title.trim() === "") {
            showCustomAlert(
                "error",
                formSurvey.id_template
                    ? "Edición de consentimiento"
                    : "Creación de consentimiento",
                "Debe ingresar el título del consentimiento informado."
            );

            return;
        }

        if (
            !Array.isArray(formSurvey.department) ||
            formSurvey.department.length === 0
        ) {
            showCustomAlert(
                "error",
                formSurvey.id_template
                    ? "Edición de consentimiento"
                    : "Creación de consentimiento",
                "Debe seleccionar al menos una sección."
            );

            return;
        }

        if (
            !Array.isArray(questions) ||
            questions.length === 0
        ) {
            showCustomAlert(
                "error",
                formSurvey.id_template
                    ? "Edición de consentimiento"
                    : "Creación de consentimiento",
                "Debe agregar al menos una pregunta."
            );

            return;
        }

        let invalidQuestion = null;

        for (
            let index = 0;
            index < questions.length;
            index++
        ) {

            invalidQuestion = findInvalidQuestion(
                questions[index],
                index + 1
            );

            if (invalidQuestion) {
                break;
            }
        }


        if (invalidQuestion) {

            const questionStyle =
                getQuestionTypeStyle(
                    invalidQuestion.type
                );

            const message =
                invalidQuestion.errorType === "question"
                    ? "debe contener el texto de la pregunta."
                    : "debe contener al menos una opción de respuesta.";

            showCustomAlert(
                "warning",
                formSurvey.id_template
                    ? "Edición de consentimiento"
                    : "Creación de consentimiento",
                `
        <div style="text-align: center;">

            <div style="
                display: inline-flex;
                align-items: center;
                justify-content: center;
                padding: 6px 14px;
                color: ${questionStyle.color};
                background: ${questionStyle.background};
                border: 1px solid ${questionStyle.border};
                border-radius: 20px;
                font-size: 12px;
                font-weight: 600;
                margin-bottom: 14px;
            ">
                ${invalidQuestion.typeLabel}
            </div>

            <div style="
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 7px;
                flex-wrap: wrap;
            ">

                <span>
                    Pregunta
                </span>

                <span style="
                    width: 28px;
                    height: 28px;
                    border-radius: 50%;
                    background: ${questionStyle.background};
                    border: 1px solid ${questionStyle.border};
                    color: ${questionStyle.color};
                    font-weight: 700;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                ">
                    ${invalidQuestion.number}
                </span>

            </div>

            <div style="
                margin-top: 10px;
                color: #6B7280;
                font-size: 13px;
            ">
                ${message}
            </div>

        </div>
        `
            );

            return;
        }


        const associatedSections = formSurvey.department
            .map(section => {

                if (
                    typeof section === "object" &&
                    section !== null
                ) {
                    return Number(
                        section.id ??
                        section.value ??
                        section.id_section
                    );
                }

                return Number(section);
            })
            .filter(id => !Number.isNaN(id));

        const payload = {
            title: formSurvey.title.trim(),

            version:
                formSurvey.version?.trim() ||
                "1.0.0",

            is_active:
                Boolean(formSurvey.is_active),

            associated_sections:
                associatedSections,

            questions: questions
                .map(buildQuestionPayload)
                .filter(Boolean),

            patient_signature:
                formSurvey.patient_signature ?? false,

            phlebotomist_signature:
                formSurvey.phlebotomist_signature ?? false
        };

        const isEditing =
            Number(formSurvey.id_template) > 0;

        console.log(
            isEditing
                ? "Payload de actualización:"
                : "Payload de creación:",
            JSON.stringify(payload, null, 2)
        );

        try {

            const response = isEditing
                ? await updateConfigurationSurvey(
                    payload,
                    formSurvey.id_template
                )
                : await saveConfigurationSurvey(
                    payload
                );

            if (response?.code === 200) {

                showToastAlert(
                    "success",
                    "Éxito",
                    isEditing
                        ? "La encuesta se actualizó correctamente."
                        : "La encuesta se generó correctamente."
                );

                clearSurvey();

                setTimeout(() => {

                    isEditing
                        ? LisSurvey2()
                        : LisSurvey();

                }, 1500);

                return;
            }

            showCustomAlert(
                "error",
                isEditing
                    ? "Edición de consentimiento"
                    : "Creación de consentimiento",

                response?.msg ||
                response?.data?.msg ||
                response?.data?.message ||
                "No fue posible guardar la encuesta."
            );

        } catch (error) {

            console.error(
                isEditing
                    ? "Error al actualizar la plantilla:"
                    : "Error al guardar la plantilla:",
                error
            );

            const errorMessage =
                error?.response?.data?.msg ||
                error?.response?.data?.message ||
                error?.message ||
                "Ocurrió un error al guardar la encuesta.";

            showCustomAlert(
                "error",
                isEditing
                    ? "Edición de consentimiento"
                    : "Creación de consentimiento",
                errorMessage
            );
        }
    };

    const handleRestoreDemo = (_valid) => {

        if (_valid) {
            setShowAlert(true);
            return;
        }

        clearSurvey();
    };

    const clearSurvey = () => {

        setFormSurvey({
            title: "",
            version: "1.0.0",
            department: []
        });

        setQuestions([]);
        setTimeValue("");
        setSelectedClosedOptions({});
        setOpenSubQuestionAnswers({});
        setTimeSubQuestionAnswers({});
        setSingleMultipleSubAnswers({});
        setMultipleSubAnswers({});
        setTimeNotApplicable(false);
    };

    const confirmRestore = () => {

        setShowAlert(false);

        clearSurvey();
    };

    const cancelRestore = () => {

        setShowAlert(false);
    };


    // *       ------------------------------ VIEW TEMPLATE SURVEY ----------------------------------------  *//

    // * LIST SURVEY
    const getListTemplateSurvey = async () => {

        const data = await getAllTemplateConfiguration();

        if (data?.code === 200) {
            setListSurveys(data?.data ?? [])
        }
    }


    // * EDIT SURVEY
    const handleEditSurvey = (survey) => {

        history.push({
            pathname: `${process.env.PUBLIC_URL}/plantillas/${survey?.id_template}/editar`,
            state: {
                survey
            }
        });

    };


    const handleToggleSurvey = async (survey) => {

        const newStatus = !survey?.is_active;

        setListSurveys((currentSurveys) =>
            currentSurveys.map((item) =>
                item?.id_template === survey?.id_template
                    ? {
                        ...item,
                        is_active: newStatus
                    }
                    : item
            )
        );


    };



    // * CONFIGURATION UPDATE STATUS TEMPLATE SURVEY
    const handleOpenEnableDialog = (template) => {
        setSelectedTemplate(template);
        setShowEnableDialog(true);
    };

    const handleCloseEnableDialog = () => {
        if (loadingStatus) {
            return;
        }

        setShowEnableDialog(false);
        setSelectedTemplate(null);
    };

    const handleEnableTemplate = async () => {
        if (!selectedTemplate?.id_template) {
            return;
        }

        try {
            setLoadingStatus(true);
            const response = await enableTemplateConfiguration(selectedTemplate?.id_template);

            if (response?.code === 200) {

                showToastAlert(
                    "success",
                    "Éxito",
                    "EL consentimiento informado se liberó correctamente."
                );

                handleCloseEnableDialog();
                await getListTemplateSurvey();

            }

        } catch (error) {
            showCustomAlert(
                "error",
                "Liberación de consentimiento",
                "Ocurrió un error al liberar el consentimiento."
            );

        } finally {
            setLoadingStatus(false);
            setShowEnableDialog(false);
            setSelectedTemplate(null);
        }
    };


    // * CONFIGURATION DELETE TEMPLATE SURVEY
    const handleOpenDeleteDialog = (survey) => {
        setTemplateToDelete(survey);
        setShowDeleteDialog(true);
    };

    const handleCloseDeleteDialog = () => {
        if (loadingDelete) {
            return;
        }

        setShowDeleteDialog(false);
        setTemplateToDelete(null);
    };



    // * DELETE TEMPLATE SURVEY
    const handleDeleteTemplateSurvey = async () => {
        if (!templateToDelete?.id_template) {
            return;
        }

        try {
            setLoadingDelete(true);

            const response = await deleteTemplateConfiguration(
                templateToDelete?.id_template
            );

            if (response?.code === 200) {
                showToastAlert(
                    "success",
                    "Éxito",
                    "La plantilla se desactivó correctamente."
                );

                setShowDeleteDialog(false);
                setTemplateToDelete(null);

                await getListTemplateSurvey();
            }
        } catch (error) {
            console.error("Error al desactivar la plantilla:", error);

            showCustomAlert(
                "error",
                "Desactivación de plantilla",
                "Ocurrió un error al desactivar la plantilla."
            );
        } finally {
            setLoadingDelete(false);
        }
    };



    // * CONFIGURATION CLAUSES
    const handleOpenClausesDialog = (survey) => {
        setTemplateToClauses(survey);
        setShowClauses(true);
        setClausesForm({
            clauses_1: survey?.clauses_1 || "",
            clauses_2: survey?.clauses_2 || "",
            id_template: survey?.id_template ?? 0
        });
    };

    const handleCloseClausesDialog = () => {

        setShowClauses(false);
        setTemplateToClauses(null);
    };


    const handleChangeClause = (field, value) => {

        setClausesForm(prev => ({
            ...prev,
            [field]: value
        }));
    };


    // * SAVE CLAUSES
    const handleSaveClauses = async () => {

        setLoadingClauses(true);

        try {

            const payload = {
                id_template: clausesForm.id_template,
                clauses_1: clausesForm.clauses_1?.trim() || null,
                clauses_2: clausesForm.clauses_2?.trim() || null
            };

            const response = await updateClausesSurvey(payload);

            if (response.code === 200) {
                getListTemplateSurvey()
                setShowClauses(false);
                showToastAlert(
                    "success",
                    "Éxito",
                    "Se anexaron correctamente las clausulas asociadas."
                );
                setClausesForm({
                    clauses_1: "",
                    clauses_2: "",
                    id_template: null
                });
            }
            else {
                showToastAlert(
                    "warning",
                    "Éxito",
                    "No se puede actualizar esta información, en el consentimiento."
                );

                console.log(
                    "Error al guardar cláusulas:",
                    response.msg
                );

            }

        }
        catch (error) {

            console.log(
                "🚀 ~ handleSaveClauses ~ error:",
                error
            );

        }
        finally {
            setLoadingClauses(false);
        }
    };



    // * PREVIEW SURVEY
    const [showSurveyPreview, setShowSurveyPreview] = useState(false);
    const [selectedSurvey, setSelectedSurvey] = useState(null);
    const [dragOffset, setDragOffset] = useState({
        x: 0,
        y: 0
    });
    const handleOpenSurveyPreview = (survey) => {
        setSelectedSurvey(survey);
        setShowSurveyPreview(true);
    };

    const handleCloseSurveyPreview = () => {
        setShowSurveyPreview(false);
        setSelectedSurvey(null);
    };



    // * CONFIGURATION ORDER QUESTIONS
    const handleOpenOrderDialog = () => {

        const ordered = [...questions]
            .sort(
                (a, b) =>
                    Number(a?.sortOrder || 0) -
                    Number(b?.sortOrder || 0)
            );

        setOrderQuestions(ordered);

        setShowOrderDialog(true);
    };



    const [dragPosition, setDragPosition] =
        useState({
            x: 0,
            y: 0
        });

    const [dragWidth, setDragWidth] =
        useState(0);


    const handleDragStartQuestion = (
        e,
        index
    ) => {

        setDraggedQuestionIndex(index);

        const rect =
            e.currentTarget.getBoundingClientRect();

        setDragWidth(rect.width);


        setDragOffset({
            x: e.clientX - rect.left,
            y: e.clientY - rect.top
        });


        setDragPosition({
            x: e.clientX,
            y: e.clientY
        });


        const transparentImage =
            document.createElement("canvas");

        transparentImage.width = 1;
        transparentImage.height = 1;

        e.dataTransfer.setDragImage(
            transparentImage,
            0,
            0
        );

        e.dataTransfer.effectAllowed =
            "move";
    };


    const handleDragQuestion = (e) => {

        if (
            e.clientX === 0 &&
            e.clientY === 0
        ) {
            return;
        }

        setDragPosition({
            x: e.clientX,
            y: e.clientY
        });
    };


    const handleDragEnterQuestion = (
        index
    ) => {

        if (
            draggedQuestionIndex === null
        ) {
            return;
        }

        setDragOverQuestionIndex(
            index
        );
    };

    const handleDragEndQuestion = () => {

        if (
            draggedQuestionIndex !== null &&
            dragOverQuestionIndex !== null &&
            draggedQuestionIndex !== dragOverQuestionIndex
        ) {

            setOrderQuestions(prev => {

                const updated =
                    [...prev];

                const [movedQuestion] =
                    updated.splice(
                        draggedQuestionIndex,
                        1
                    );

                updated.splice(
                    dragOverQuestionIndex,
                    0,
                    movedQuestion
                );

                return updated;
            });
        }

        setDraggedQuestionIndex(null);

        setDragOverQuestionIndex(null);

        setDragWidth(0);
    };

    const handleSaveQuestionOrder = () => {

        const reorderedQuestions =
            orderQuestions.map(
                (question, index) => ({
                    ...question,
                    sortOrder: index + 1
                })
            );



        showToastAlert(
            "warning",
            "Ordenamiento",
            formSurvey.id_template > 0
                ? "Debe de actualizar la plantilla para guardar el ordenamiento seleccionado"
                : "Debe de guardar la plantilla para guardar el ordenamiento seleccionado",
        );


        setShowOrderDialog(false);
        setQuestions(reorderedQuestions);

    };























    return {

        // ? CONFIGURATION STATES
        formSurvey,
        questions,
        setTimeValue,
        timeValue,

        // ?  CONFIGURATION HANDLES
        handleRestoreDemo,
        handleChangeSurvey,
        handleAddQuestion,
        handleUpdateQuestion,
        handleDeleteQuestion,

        // ? CONFIGURATION PREVIEW
        handleSelectClosedOption,
        selectedClosedOptions,
        openSubQuestionAnswers,
        timeSubQuestionAnswers,
        setOpenSubQuestionAnswers,
        setTimeSubQuestionAnswers,

        singleMultipleSubAnswers,
        handleTimeChange,
        fastingTime,
        timeNotApplicable,
        handleMultipleSubAnswer,
        multipleSubAnswers,
        setSingleMultipleSubAnswers,


        // ? CONFIGURATION METHODS
        departments,


        // ? ALERT
        showToast,
        toastType,
        toastTitle,
        toastMessage,
        closeToastAlert,


        // ? CONFIGURATION QUESTIONS SURVEY
        multipleAnswers,
        handleMultipleAnswerChange,
        handleSingleAnswerChange,
        singleAnswers,
        handleSave,
        customAlert,
        createSurvey,
        LisSurvey,
        showAlert,
        confirmRestore,
        cancelRestore,


        // ? EDIT SURVEY
        listSurveys,
        handleEditSurvey,
        handleToggleSurvey,
        idTemplate,
        LisSurvey2,
        handleDeleteTemplateSurvey,


        // ?  CONFIGURATION UPDATE STATUS TEMPLATE SURVEY
        showEnableDialog,
        selectedTemplate,
        handleOpenEnableDialog,
        handleCloseEnableDialog,
        handleEnableTemplate,
        loadingStatus,


        // ?  CONFIGURATION DELETE TEMPLATE SURVEY
        showDeleteDialog,
        handleCloseDeleteDialog,
        templateToDelete,
        loadingDelete,
        handleOpenDeleteDialog,


        // ? PREVIEW SURVEY
        selectedSurvey,
        showSurveyPreview,
        handleOpenSurveyPreview,
        handleCloseSurveyPreview,

        handleToggleSignature,


        // ? ORDER
        handleOpenOrderDialog,
        showOrderDialog,
        setShowOrderDialog,
        handleSaveQuestionOrder,
        orderQuestions,
        handleDragStartQuestion,
        handleDragEnterQuestion,
        handleDragEndQuestion,
        draggedQuestionIndex,
        dragOverQuestionIndex,
        getQuestionTypeLabel,


        dragWidth,
        dragPosition,
        handleDragQuestion,
        dragOffset,


        // ? CLAUSES
        handleOpenClausesDialog,
        handleCloseClausesDialog,
        templateToClauses,
        loadingClauses,
        showClauses,
        clausesForm,
        handleChangeClause,
        handleSaveClauses




    }
}
